import defaultTheme from './defaultTheme';

export { defaultTheme };